import { useEffect, useState } from 'react';
import { requestGet } from '../../Helpers';

export const useChekingAuth = () => {
    const [logged, setLogged] = useState(false);



    useEffect( () => {

        const token = JSON.parse(localStorage.getItem('user_store_ecommerce'));

        if (!token) {
            setLogged({
                logged: false,
                user: {}
            })
        }

        requestGet(`login/?token=${token}`)
            .then((resp) => {
                
                if (typeof resp === 'object') {
                    const {name, email, is_superuser, is_staff, is_active} = resp.user;

                    setLogged({
                        logged: !!resp,
                        user: {
                            nombres: name,
                            correo: email,
                            is_superuser,
                            is_staff,
                            is_active,
                            token
                        }
                    })
                } else {
                    setLogged({
                        logged: false,
                        user: {}
                    })
                }
                
            })
            .catch((error) => {
                new Error(error);
            })

    }, []);

    return { logged };
}
